/**
 * claimedRewards — the character-scoped list of one-time world rewards a character has claimed
 * (a chest at the end of a jump course, a hidden cache). Keys are `<mapId>:<rewardId>`, so the same
 * reward id may exist on different maps. Claims are monotonic: a reward is claimed once per
 * character, never re-armed by a refresh or another session.
 */

/** Bound on the persisted list. */
export const MAX_CLAIMED_REWARDS = 256;

const KEY = /^[a-z0-9_]{1,64}:[a-z0-9_]{1,64}$/;

export function claimedRewardKey(mapId: string, rewardId: string): string {
  return `${mapId}:${rewardId}`;
}

export function isClaimedRewardKey(value: unknown): value is string {
  return typeof value === 'string' && KEY.test(value);
}

/** Keep only distinct, well-formed keys, in first-claimed order. */
export function normalizeClaimedRewards(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const claimed: string[] = [];
  for (const key of value) {
    if (!isClaimedRewardKey(key) || claimed.includes(key)) continue;
    claimed.push(key);
    if (claimed.length >= MAX_CLAIMED_REWARDS) break;
  }
  return claimed;
}
